"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Expander = void 0;
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var react_transition_group_1 = require("react-transition-group");
var BASE_CLASS_NAME = "expander";
var Expander = (function (_super) {
    __extends(Expander, _super);
    function Expander(props) {
        var _this = _super.call(this, props) || this;
        _this.isFullyOpen = props.open;
        _this.innerRef = react_1.default.createRef();
        if (!_this.props.open) {
            _this.contentHeight = 0;
        }
        return _this;
    }
    Expander.prototype.postExpandHandler = function () {
        var _a, _b;
        (_b = (_a = this.props).onExpanded) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    Expander.prototype.postCollapseHandler = function () {
        var _a, _b;
        (_b = (_a = this.props).onCollapsed) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    Expander.prototype.render = function () {
        var _a;
        var _this = this;
        var isFullyOpen = this.isFullyOpen;
        var shouldDisplayNoneContents = !(this.props.open || isFullyOpen);
        return (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: this.props.open, timeout: { enter: kaleidoscope_1.AnimationDuration.Medium, exit: kaleidoscope_1.AnimationDuration.Short }, classNames: "".concat(BASE_CLASS_NAME, "__outer-"), onEnter: function () {
                _this.contentHeight = 0;
                requestAnimationFrame(function () {
                    var _a;
                    _this.contentHeight = (_a = _this.innerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight;
                });
            }, onExit: function () {
                var _a;
                _this.contentHeight = (_a = _this.innerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight;
                requestAnimationFrame(function () {
                    _this.contentHeight = 0;
                });
            }, onEntered: function () {
                _this.isFullyOpen = true;
                _this.postExpandHandler();
                _this.contentHeight = undefined;
            }, onExited: function () {
                _this.isFullyOpen = false;
                _this.postCollapseHandler();
            } },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(BASE_CLASS_NAME, "__outer"), (_a = {}, _a["".concat(BASE_CLASS_NAME, "__outer--open")] = isFullyOpen, _a)), style: { height: this.contentHeight, display: shouldDisplayNoneContents ? "none" : undefined } },
                react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__inner"), ref: this.innerRef }, this.props.children))));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Expander.prototype, "contentHeight", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], Expander.prototype, "isFullyOpen", void 0);
    Expander = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Expander);
    return Expander;
}(react_1.default.Component));
exports.Expander = Expander;
